import { components } from 'react-select';
import { KeenIcon, DefaultTooltip } from '@/components';

const CustomOption = (props) => (  
  <components.Option {...props}>
    <div className="flex flex-col leading-tight">
      <span className="mb-0.5">{props.data.label}</span>
      {props?.data?.email ? (<span className="badge badge-xs badge-pill badge-outline w-fit !lowercase">{props.data.email}</span>) : <span className="badge badge-xs badge-pill badge-outline w-fit">No Email</span> }
    </div>
  </components.Option>
);

const CustomSingleValue = (props) => (  
  <components.SingleValue {...props}>
    <div>
      {props.data.label}{' '}
      {props.data.email && <span className="text-xs text-gray-400 !lowercase">({props.data.email})</span>}
    </div>
  </components.SingleValue>
);

const CustomOptionWithTooltip = (props) => {
  const { data, innerRef, innerProps, isFocused, isSelected } = props;
  const isDisabled = !data.email;

  const content = (
    <div
      ref={innerRef}
      {...innerProps}
      className={`px-3 py-2 text-sm ${isFocused ? 'bg-muted' : ''
        } ${isSelected ? 'font-medium' : ''} ${isDisabled ? 'cursor-not-allowed text-muted-foreground bg-muted' : 'cursor-pointer'
        }`}
      style={{ pointerEvents: 'auto' }}
    >
      <div className="font-medium">{data.label}</div>
      <div className="badge badge-xs badge-pill badge-outline w-fit">{data.email || 'No email'}</div>
    </div>
  );

  return isDisabled ? (
    <DefaultTooltip title="No email for this contact">
      <div>{content}</div>
    </DefaultTooltip>
  ) : (
    content
  );
};

const CustomSingleValueWithTooltip = (props) => {
  const { data } = props;
  const content = (
    <div>
      {data.label}{' '}
      {data.email && (
        <span className="text-xs text-gray-400">({data.email})</span>
      )}
    </div>
  );

  return data.email ? (
    <components.SingleValue {...props}>{content}</components.SingleValue>
  ) : (
    <DefaultTooltip
      title="No email available"
      placement="top"
      className="max-w-full"
    >
      <components.SingleValue {...props}>{content}</components.SingleValue>
    </DefaultTooltip>
  );
};

export {
  CustomOption,
  CustomSingleValue,
  CustomOptionWithTooltip,
  CustomSingleValueWithTooltip,
};